<template>
    <div>
        <custom-tooltip border>
            <app-button border icon @click="openScanner">📡</app-button>

            <template #tooltip> Buscar con Scanner </template>
        </custom-tooltip>

        <app-dialog v-model="openModalScanner" @close="stopListener">
            <div>
                <div class="flex flex-col justify-center items-center">
                    <h3 class="my-2 mx-3">
                        {{
                            $isPhone
                                ? "Estas usando un dispositivo movil, el scanner no puede operar."
                                : "Por favor, conecta el scanner"
                        }}
                    </h3>

                    <div>
                        <div class="flex mt-4">
                            <custom-input
                                id="barcode"
                                v-model="barcode"
                                type="text"
                                label="Ingreso Manual"
                                name="barcode"
                                class="w-full mr-2"
                                aria-label="Barcode"
                                @focus="stopListener"
                                @blur="startListener"
                                @enter="onClickSearch"
                            />
                            <app-button circle icon @click="onClickSearch">
                                🔎
                            </app-button>
                        </div>
                    </div>
                </div>
            </div>
        </app-dialog>
    </div>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "BarcodeScannerButton",
    components: { AppDialog, CustomInput },
    emits: ["change"],
    data: () => ({
        openModalScanner: false,
        timer: null,
        barcode: ""
    }),
    mounted() {
        this.startListener();
    },
    beforeDestroy() {
        this.stopListener();
    },
    methods: {
        handleListener(event) {
            if (!this.openModalScanner) return;
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.barcode += event.key;
            this.timer = setTimeout(() => {
                this.$emit("change", this.barcode);
                this.stopListener();
                this.barcode = "";
                this.openModalScanner = false;
            }, 20);
        },
        openScanner() {
            this.openModalScanner = true;
            this.startListener();
        },
        startListener() {
            if (!this.$isPhone) {
                document.addEventListener("keydown", this.handleListener);
            }
        },
        stopListener() {
            if (!this.$isPhone) {
                document.removeEventListener("keydown", this.handleListener);
            }
        },
        onClickSearch() {
            this.$emit("change", this.barcode);
            this.barcode = "";
            this.openModalScanner = false;
        }
    }
};
</script>
